import React from 'react';
import styled from 'styled-components';

const StyledVerticalStepperContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const VerticalStepperContainer: React.FC = ({ children }) => {
  return (
    <StyledVerticalStepperContainer>{children}</StyledVerticalStepperContainer>
  );
};

export default VerticalStepperContainer;
